'use client'
import React, {useState} from 'react'
import PlayIcon from '@local/assets/svgs/icon-play.svg'
import {cx} from '@local/utils/cx'
import {Button, Modal} from '@local/ui/components'
import CloseIcon from '@local/assets/svgs/icon-close.svg'

type YoutubeEmbedModalProps = {
	embedLink: string,
}

const YoutubeEmbedModal = ({embedLink}:YoutubeEmbedModalProps) => {
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const handleClose = () => setModalIsOpen(false)
	const handleOpen = () => setModalIsOpen(true)
	return (
		<div>
			<Button variant='primary-transparent' onClick={handleOpen} className='absolute bottom-20 right-20 z-50 flex items-center px-2 py-4 '>
				<PlayIcon className='w-20 h-20 mr-4' alt='Play Icon' aria-hidden />
				<p className='text-12 leading-moderate tracking-snug font-[350]'>Watch Full Story</p>
			</Button>
			{modalIsOpen &&
				<Modal
					isActive={modalIsOpen}
					onClickClose={handleClose}
					backdropClassName='bg-black opacity-50'
					className='h-3/4 w-3/4 top-20 bg-transparent pt-40 '>
					<Button
						onClick={handleClose} className={cx(
							'absolute top-10 right-10 text-white w-24 h-24 [&_svg]:w-full [&_svg]:h-full p-4 z-20',
						)}>

						<CloseIcon />
					</Button>
					<iframe width='100%' height='100%' src={embedLink} allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' referrerPolicy='strict-origin-when-cross-origin' allowFullScreen />
				</Modal>}
		</div>
	)
}

export default YoutubeEmbedModal
